/**
 * File manifest-money.js.
 * Handles logic for the Manifest Money template.
 */

const mmSlider = document.querySelector('.manifest-money__slides');
const mmArrowPrev = document.querySelector('.manifest-money__slider-arrow--prev');
const mmArrowNext = document.querySelector('.manifest-money__slider-arrow--next');

function manifestSlider($) {
  $(mmSlider).slick({
    infinite: false,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: true,
    autoplay: false,
    pauseOnDotsHover: true,
    lazyLoad: 'anticipated',
    prevArrow: mmArrowPrev,
    nextArrow: mmArrowNext
  });
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(document).ready(function ($) {
  manifestSlider($);
});
